import { Image } from 'antd';
import styled from 'styled-components';

export const ItemWrapper = styled.div`
  width: 450px;
  padding: 12px 0;
  border-radius: 12px;
  height: 56px;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

export const ItemName = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  // to truncate string using ellipsis
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`;

export const ItemCaption = styled.div`
  display: block;
  margin-left: 12px;
  min-width: 0;
`;

export const ItemImage = styled(Image)`
  && {
    width: 52px;
    height: 52px;
    border-radius: 16px;
  }
`;
